import { Injectable } from "@angular/core";

import { Logger } from "./logger";
import { Log } from "./logging.model";
import { LoggingService } from "./logging.service";

@Injectable({
	providedIn: "root",
})
export class LoggingFactory {
	constructor(private loggingService: LoggingService) {}

	get(sourceId: string): Log {
		return new Logger(sourceId, this.loggingService);
	}
}
